import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import Propiedades from "./pages/Propiedades.tsx";
import Propiedad from "./pages/Propiedad.tsx";
import Admin from "./pages/Admin.tsx";
import Contacto from "./pages/Contacto.tsx";
import Proximamente from "./pages/Proximamente.tsx";
import NotFound from "./pages/NotFound.tsx";
import PageviewTracker from "./components/PageviewTracker.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <PageviewTracker />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/Inicio" element={<Navigate to="/" replace />} />
          <Route path="/Propiedades" element={<Propiedades />} />
          <Route path="/Propiedad" element={<Propiedad />} />
          <Route path="/Alquileres" element={<Proximamente titulo="Alquileres" descripcion="Estamos preparando nuestra selección de alquileres en el Vallès Occidental y provincia de Barcelona. Muy pronto podrás consultarlos aquí." path="/Alquileres" />} />
          <Route path="/Servicios" element={<Proximamente titulo="Servicios" descripcion="Estamos ultimando la presentación de nuestros servicios de construcción y reformas. Muy pronto disponibles." path="/Servicios" />} />
          <Route path="/Contacto" element={<Contacto />} />
          <Route path="/contacto" element={<Navigate to="/Contacto" replace />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
